export function isLand(height) {
  return height >= 0.0 && height < 0.75
}
export function isWater(height) {
  return height < 0.0
}
export function isHill(height) {
  return height >= 0.375 && height < 0.75
}
export function isMountain(height) {
  return height >= 0.75
}
